<div class="grid cols-1fr-3fr">
  <div>
    {{ 'benefits.profile-benefit-mgt.benefit-label' | translate | titlecase }}
  </div>
  <div class="flex column gap-10px">
    <div [hidden]="!availableBenefitTypes" class="w-100">
      <select [(ngModel)]="benefit.BenefitTypeId" class="form-control" (ngModelChange)="onBenefitTypeChange($event)">
        <option value="0">{{ 'common.select' | translate | titlecase }}</option>
        <option *ngFor="let benefit of availableBenefitTypes" [value]="benefit.Id">
          {{ benefit.Name }}
        </option>
      </select>
    </div>
    <div [hidden]="availableBenefitTypes">
      <p>
        {{ 'benefits.profile-benefit-mgt.member-has-all-benefits-message' }}
      </p>
    </div>
    <div class="flex row-collapse space-between">
      <div class="flex column w-33">
        {{ 'benefits.profile-benefit-mgt.dollar-value-label' | translate | titlecase }}
        <div class="input-group">
          <wl-currency-symbol class="input-group-addon"></wl-currency-symbol><p-input-number [showButtons]="true"
            mode="decimal" [min]="0.0" [step]="0.01" [minFractionDigits]="0" [maxFractionDigits]="2"
            [(ngModel)]="benefit.Value"></p-input-number>
        </div>
      </div>
      <div class="flex column items-end w-33">
        <span class="t-ar w-50">{{ 'common.revenue.quantity' | translate | titlecase }}</span>
        <p-input-number class="w-50" [showButtons]="true" [min]="0" [step]="1"
          [(ngModel)]="benefit.Quantity"></p-input-number>
      </div>
      <div class="flex column items-end w-33">
        <div class="t-ar">{{ 'benefits.profile-benefit-mgt.total-value-label' | translate | titlecase }}</div>
        <div class="t-ar">{{ benefit.Quantity * benefit.Value | currency }}</div>
      </div>
    </div>
    <hr />
  </div>
  <div>
    {{ 'benefits.profile-benefit-mgt.expiration-date-label' | translate | titlecase }}
  </div>
  <div class="flex column gap-10px">
    <div [hidden]="!createMode">
      <div>
        <label><input type="radio" [(ngModel)]="useDuesBillingDate" [value]="true"
            (change)="onExpirationDateUseChanged(true)" />{{
          'benefits.profile-benefit-mgt.use-dues-billing-anchor-label' | translate | titlecase
          }}</label>
      </div>
      <div>
        <label><input type="radio" [(ngModel)]="useDuesBillingDate" [value]="false"
            (change)="onExpirationDateUseChanged(false)" />{{
          'benefits.profile-benefit-mgt.use-specific-date-label' | translate | titlecase
          }}</label>
      </div>
    </div>
    <div>
      <wl-date-selector [(ngModel)]="benefit.ExpirationDate"></wl-date-selector>
    </div>
    <div>
      <label class="input-group">
        <input type="checkbox" [(ngModel)]="benefit.RenewAnnually" />
        {{ 'benefits.profile-benefit-mgt.renew-annually-label' | translate | titlecase }}
      </label>
    </div>
    <div>
      <label [hidden]="createMode" class="input-group">
        <input type="checkbox" [(ngModel)]="benefit.Active" />
        {{ 'common.active' | translate | titlecase }}
      </label>
    </div>
  </div>
</div>
